import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import { IAction } from '~/src/store';

import { EContactAlertActions } from './index';

export interface IResultState {
    isOpen: boolean,
    type: EResultPopupStatus,
    title: string,
    text?: string,
}

export type TSetResult = IAction<EContactAlertActions.SET_RESULT, IResultState>;

const setResult = (result: IResultState): TSetResult => ({
    type: EContactAlertActions.SET_RESULT,
    payload: result,
});

export default setResult;
